import React from 'react'

import cashEventImage from '@assets/images/cashflow_event_image.png'

import { BackToDashboardButton } from '../../Components/BackToDashboardButton'
import { RefreshButton } from '../../Components/RefreshButton'

export const ConsentGranted = () => {
  return (

  <div className='astute-request-wrapper'>
    <h1>Preparing client report</h1>
    <p className='astute-request-wrapper--subheading'>
      Digital consent has been granted!
    </p>
    <img
      src={cashEventImage}
      alt='astute pending graphic'
      className='astute-request-wrapper--graphic'
    />
    <p className='astute-request-wrapper--link-text'>
      Great news! Your client has provided digital consent. We are busy retrieving some data from Astute.<br />Your report will be ready shortly - check back soon!
    </p>
    <div className='astute-back-to-dashboard'>
      <BackToDashboardButton />
      <div className='refresh-button-wrapper'>
        <RefreshButton />
      </div>
    </div>
  </div>
  )
}
